import { render, staticRenderFns } from "./associa-permessi.vue?vue&type=template&id=6b80ad44&"
import script from "./associa-permessi.vue.ts?vue&type=script&lang=ts&"
export * from "./associa-permessi.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports